"use strict";
var publishBehavior_1 = require('../operators/publishBehavior');
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return publishBehavior_1.publishBehavior(value)(this);
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/operator/publishBehavior.js
// module id = 856
// module chunks = 0